<template>
  <div>
    <div class="type-wrapper">
      <button
        v-for="(button, index) in buttonsExtractors"
        :key="index"
        @click="setType(button.type)"
      >
        <div :class="{ active: type === button.type }">
          <component
            :is="getChartsComponent(button.type)"
            :id="`${question_result.code}-${button.type}`"
            :changeColor="type === button.type"
          />
        </div>

        <span> {{ button.label }} </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { CHART_TYPES } from '../chartConfig'

import LineIcon from '@/components/imgs/LineIcon'
import BarIcon from '@/components/imgs/BarIcon'
import BarHorizontalIcon from '@/components/imgs/BarHorizontalIcon'
import PieIcon from '@/components/imgs/PieIcon'
import StackedBarIcon from '@/components/imgs/StackedBarIcon'

import * as translationTypes from './types.translations'

const { default: translations, ...translationKeys } = translationTypes

export default {
  name: 'ConfigType',

  components: { LineIcon, BarIcon, BarHorizontalIcon, PieIcon, StackedBarIcon },

  props: {
    question_result: {
      required: true,
      type: Object,
    },

    groupCode: {
      required: true,
    },
  },

  data() {
    return {
      type: CHART_TYPES.BAR,
      CHART_TYPES,

      translations,
      ...translationKeys,
    }
  },

  computed: {
    ...mapGetters(['chartSettings']),

    buttonsExtractors() {
      const buttonsExtractors = [
        {
          type: CHART_TYPES.BAR,
          label: this.parseTranslation(this.BAR_CHART),
        },

        {
          type: this.CHART_TYPES.BAR_HORIZONTAL,
          label: this.parseTranslation(this.HORIZONTAL_BAR_CHART),
        },

        {
          type: CHART_TYPES.STACKED_BAR,
          label: this.parseTranslation(this.STACKED_BAR_CHART),
        },

        {
          type: CHART_TYPES.LINE,
          label: this.parseTranslation(this.LINE_CHART),
        },

        {
          type: CHART_TYPES.PIE,
          label: this.parseTranslation(this.PIE_CHART),
        },
      ]

      return buttonsExtractors
    },
  },

  methods: {
    ...mapActions(['setChartType', 'setChartSettings']),

    setType(chartType) {
      this.type = chartType

      this.setChartSettings({
        setting: {
          ...this.question_result?.chartSettings,

          type: chartType,
        },

        groupCode: this.groupCode,
        questionCode: this.question_result.code,
      })
    },

    getChartsComponent(type) {
      switch (type) {
        case CHART_TYPES.BAR:
          return 'BarIcon'
        case CHART_TYPES.BAR_HORIZONTAL:
          return 'BarHorizontalIcon'
        case CHART_TYPES.PIE:
          return 'PieIcon'
        case CHART_TYPES.LINE:
          return 'LineIcon'
        case CHART_TYPES.STACKED_BAR:
          return 'StackedBarIcon'
        default:
          throw new Error(`${type} is not a valid chart type`)
      }
    },
  },

  mounted() {
    this.type = this.question_result?.chartSettings?.type || CHART_TYPES.BAR
  },
}
</script>

<style lang="scss" scoped>
.title {
  @include chart-config-title;
}

.type-wrapper {
  @include flexMiddle;
  flex-wrap: wrap;
  margin: 20px 0;

  button {
    @include flexMiddle;
    flex-direction: column;
    padding: 5px;
    margin: 0 20px 15px 0;
    border: none;
    background: $transparent;

    > div {
      padding: 5px;
      border: 1px solid $gray-5;
      border-radius: 3px;
      @include boxSizing(72);

      svg {
        @include boxSizing(60);
      }

      &.active {
        background: $blue;
      }
    }

    span {
      margin-top: 10px;
      @include tipography(14);

      .light & {
        color: $gray-2;
      }
    }

    &:focus {
      outline: none;
    }
  }

  @media (max-width: 400px) {
    button {
      svg {
        @include boxSizing(50);
      }
    }
  }
}
</style>
